import { createSlice } from '@reduxjs/toolkit';

const initialState = localStorage.getItem('fechasPlanificacionSesion') === 'true';

const fechasPlanificacionSesionSlice = createSlice({
	name: 'fechasPlanificacionSesionState',
	initialState,
	reducers: {
		displayFechasPlanificacionSesion: () => {
			localStorage.setItem('fechasPlanificacionSesion', 'true');
			return true;
		},
		hideFechasPlanificacionSesion: () => {
			localStorage.removeItem('fechasPlanificacionSesion');
			return false;
		}
	}
});

export const { displayFechasPlanificacionSesion, hideFechasPlanificacionSesion } =
	fechasPlanificacionSesionSlice.actions;

export default fechasPlanificacionSesionSlice.reducer;
